<template>

    <section
        :class="'main-section applicant-section p-2 my-5 col-10 offset-1 ' + (applicant.isLegal ? '' : 'bg-blink-warning')">
        <!-- Title Section -->
        <h2 class="text-center my-3 text-white text-shadow">تفاصيل الطلب</h2>
        <!-- Application Status -->
        <!-- <div class="my-3 px-2  d-flex justify-content-around text-white text-shadow flex-wrap">
            <div class="d-flex justify-content-around col-md-3 col-6">
                <h5 class="text-center  ">حالة الطلب</h5>
                <p :class="$adminAppStatus[applicant.appType][applicant.status]?.class ">{{ $adminAppStatus[applicant.appType][applicant.status]?.text }}</p>
            </div>
            ||
            <div class="d-flex justify-content-around  col-md-3 col-6">
                <h5 class="">نوع الطلب <span class="fw-normal text-secondary">(الأساسي)</span></h5>
                <p class="">{{ $appType.desc[applicant.appType] }} </p>
            </div>
            ||
            <div class="d-flex justify-content-around  col-md-3 col-6">
                <h5 class="">المركز الجمركي</h5>
                <p class="">{{ getDeparts.find(e => e.id === applicant.departId)?.name }}</p>
            </div>
        </div> -->
        <div class="row">
            <!-- General Details -->
            <div class="col col-lg-10 offset-lg-1 col-12">
                <div class="table-responsive">
                    <table class="main-table more-info table table-bordered">
                        <thead>
                            <tr class="">
                                <td class="text-end">
                                    معلومات
                                </td>
                                <td class="">
                                    الطلب
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>رقم التسجيل:</strong>
                                </td>
                                <td>
                                    {{ Id }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم التحقق:</strong>
                                </td>
                                <td>
                                    {{ applicant.checkNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>حالة الطلب:</strong>
                                </td>
                                <td :class="$adminAppStatus[applicant.appType][applicant.status]?.class ">
                                    {{ $adminAppStatus[applicant.appType][applicant.status]?.text }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>نوع الطلب <span class="fw-normal text-secondary">(الأساسي)</span> :</strong>
                                </td>
                                <td>
                                    {{ $appType.desc[applicant.appType] }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>المركز الجمركي:</strong>
                                </td>
                                <td>
                                    {{ getDeparts.find(e => e.id === applicant.departId)?.name }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>تاريخ تقديم الطلب:</strong>
                                </td>
                                <td>
                                    {{ applicant.regDate }}
                                </td>
                            </tr>
                            <template v-for="(actor, index) in applicant.actors" :key="index">
                            <tr>
                                <td>
                                    <strong>{{ actor.operation }}:</strong>
                                </td>
                                <td>
                                    {{ actor.name }}  
                                </td>
                                
                            </tr>
                            <tr >
                                <td :title="'تاريخ' + actor.operation">
                                    <strong>تاريخ العملية:</strong>
                                </td>
                                <td>
                                     {{ actor.operationDate }} 
                                </td>
                            </tr>
                            <tr v-if="actor?.note">
                                <td >
                                    <strong>ملاحظة <span class="fw-normal text-secondary">(الأساسي)</span> :</strong>
                                </td>
                                <td>
                                     {{ actor?.note }} 
                                </td>
                            </tr>
                            </template>
                            
                        </tbody>
                        
                    </table>
                </div>
            </div>
            <!-- Applicant Details -->
            <div class="col col-lg-6 col-12">
                <div class="table-responsive">
                    <table class="main-table more-info table table-bordered">
                        <thead>
                            <tr class="">
                                <td class="text-end">
                                    معلومات
                                </td>
                                <td class="">
                                    السائق
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>الاسم:</strong>
                                </td>
                                <td><b>
                                        {{ applicant.applicantName }}
                                    </b></td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم الهاتف:</strong>
                                </td>
                                <td><b>
                                        {{ applicant.phoneNo }}
                                    </b></td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>المدينة:</strong>
                                </td>
                                <td>
                                    {{ applicant.cityName }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>العنوان:</strong>
                                </td>
                                <td>
                                    {{ applicant.address }}</td>
                            </tr>
                            <tr v-if="applicant.nationalityId == 1">
                                <td>
                                    <strong>الرقم الوطني:</strong>
                                </td>
                                <td>
                                    {{ applicant.nationNo }}
                                </td>
                            </tr>
                            <tr v-else>
                                <td>
                                    <strong>الجنسية :</strong>
                                </td>
                                <td>
                                    {{ getNationalities.find(e => e.id === applicant.nationalityId)?.name }}
                                </td>
                            </tr>
                            <tr v-if="applicant.nationalityId == 1">
                                <td>
                                    <strong>الرقم الآلي:</strong>
                                </td>
                                <td>
                                    {{ applicant.passAutoNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم الجواز:</strong>
                                </td>
                                <td>
                                    {{ applicant.passNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم رخصة القيادة:</strong>
                                </td>
                                <td>
                                    {{ applicant.licenseNo }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Vehicle Details -->
            <div class="col col-lg-6 col-12">
                <div class="table-responsive">
                    <table class="main-table more-info table table-bordered">
                        <thead>
                            <tr class="">
                                <td class="text-end">
                                    معلومات
                                </td>
                                <td class="">
                                    المركبة
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>نوع المركبة:</strong>
                                </td>
                                <td>
                                    {{ applicant.transTypeName }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>المُصنّع:</strong>
                                </td>
                                <td>
                                    {{ applicant.madeName }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>طراز المركبة:</strong>
                                </td>
                                <td>
                                    {{ applicant.transModel }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>تاريخ الصنع:</strong>
                                </td>
                                <td>
                                    {{ applicant.transDate }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم اللوحة:</strong>
                                </td>
                                <td>
                                    {{ applicant.plateNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم الهيكل:</strong>
                                </td>
                                <td>
                                    {{ applicant.chassisNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>رقم المحرك:</strong>
                                </td>
                                <td>
                                    {{ applicant.engineNo }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>لون المركبة:</strong>
                                </td>
                                <td>
                                    {{ applicant.transColor }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Documents Section -->
            <div class="my-3">
                <h4 class="text-center text-white text-shadow">المستندات المرفقة</h4>
                <div class="row row-cols-xl-4 row-cols-md-2 row-cols-1">
                    <div class="col my-2" v-for="(doc, index) in applicant.docs" :key="index">
                        <div class="card shadow-sm rounded-lg">
                            <div class="image-container">
                                <a :href="`${doc.docPath}`" target="_blank" class="" :title="'افتح الصورة'">
                                    <img :src="`${doc.docPath}`" class="card-img-top doc-thumbnail"
                                        :alt="doc.docType" />
                                </a>
                            </div>
                            <div class="card-body p-3">
                                <h6 class="card-title text-center">{{ doc.docType }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-3 d-flex justify-content-between">
                <div class="d-flex w-100">
                    <div class="col-md-2 col-4 px-2">
                        <button v-if="applicant.status == 1" class="btn btn-primary w-100 my-1 " type="button"
                            data-bs-toggle="modal" data-bs-target="#acceptApp"
                            :disabled="!(getUser?.privs.includes('accept') && applicant.isLegal) ?? true">
                            قبول <font-awesome-icon icon="fa-solid fa-circle-check" />
                        </button>
                        <button v-if="applicant.status == 2" class="btn btn-primary w-100 my-1" type="button"
                        data-bs-toggle="modal" data-bs-target="#arriveApp"
                        :disabled="!(getUser?.privs.includes('returnAccepted') && applicant.isLegal) ?? true">
                        رجوع المركبة <font-awesome-icon icon="fa-solid fa-circle-check" />
                    </button>
                    <button v-if="applicant.hasExcept" class="btn btn-secondary w-100 my-1" @click="getExceptList()"
                        data-bs-toggle="modal" data-bs-target="#extension-list"
                        :disabled="!(getUser?.privs.includes('extention')) ?? true">
                        عرض الاستثناءات <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                    </button>
                    <button v-if="applicant.status == 2" class="btn btn-secondary w-100 my-1" type="button"
                        @click="printPdf"
                        :disabled="!(getUser?.privs.includes('accept') && applicant.isLegal) ?? true">
                        طباعة الإيصال <font-awesome-icon icon="fa-solid fa-print" />
                    </button>
                        <!-- <router-link  v-if="applicant.status == 4 && applicant.hasExcept" class="btn btn-info" :to="'/admin/applicant/extrequest/' + Id + '/2' ">
                            عرض محضر الاستدلال <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> 
                        </router-link>
                        <router-link  v-if="applicant.status == 5 && applicant.hasExcept" class="btn btn-info" :to="'/admin/applicant/extrequest/' + Id + '/3' ">
                            عرض طلب الإسقاط <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> 
                        </router-link> -->
                    </div>
                    <div v-if="applicant.status == 2 " class="col-md-2 col-4 px-2">
                        <button class="btn btn-warning text-white w-100 my-1 " type="button" 
                        data-bs-toggle="modal" data-bs-target="#investAppModal"
                        :disabled="!(getUser?.privs.includes('dropping')) ?? true">
                            رجوع استثنائي <font-awesome-icon icon="fa-solid fa-circle-check" />
                        </button>
                    </div>
                    <div v-if="applicant.status == 2 && (getUser?.privs.includes('dropping'))" class="col-md-2 col-4 px-2">
                        <button class="btn btn-warning text-white w-100 my-1 " type="button" 
                        data-bs-toggle="modal" data-bs-target="#dropAppModal">
                            اسقاط <font-awesome-icon icon="fa-solid fa-ban" />
                        </button>
                    </div>
                </div>
                <div class="col-md-2 col-4 px-2">
                    <button @click="$router.go(-1)" class="btn btn-secondary w-100 my-1 " type="button">عودة
                        <font-awesome-icon icon="fa-regular fa-circle-left" />
                    </button>
                </div>
            </div>
        </div>

    </section>
    <GeneralModal :modalTitle="'قبول الطلب'" :modalId="'acceptApp'" :modalFormLabel="acceptAppLabel" :inputFields="acceptModalFields"
        :modalSubmitFnc="'modalSubmit'" />
    <GeneralModal :modalTitle="'إنهاء إجراءات الرجوع'" :modalId="'arriveApp'" :modalFormLabel="''" :inputFields="arriveModalFields"
        :modalSubmitFnc="'arriveVehicle'" />
    <alert-modal ref="alertModal" :redirectUrl="'/admin/applicantsearch'" :alertContent="alertContent"
        :alertSubject="alertSubject" :isDismiss="false" />
        <exception-list-modal :excList="exceptionList" :exceptType="1" />
    <GeneralModal :modalId="'investAppModal'" :modalTitle="'محضر استدلال'"
        :modalFormLabel="'رجوع المركبة استثنائيا بمحضر استدلال'" :documents="investDocs"
        :inputFields="investFields" :modalSubmitFnc="'investArrive'" />
    <GeneralModal :modalId="'dropAppModal'" :modalTitle="'اسقاط المركبة'"
        :modalFormLabel="'اسقاط المركبة استثنائياً بمحضر استدلال'" :documents="dropDocs"
        :inputFields="dropFields" :modalSubmitFnc="'dropVehicle'" :modalSubmitText="'إسقاط'"/>
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { Modal } from 'bootstrap';
import { mapGetters, mapActions } from 'vuex';
import ExceptionListModal from '@/components/EmployeeApp/ExceptionListModal.vue';

export default {
    data() {
        return {
            Id: this.$route.params.Id, // Get the applicantId from the route params
            applicant: {
                applicantName: '',
                phoneNo: '',
                cityName: '',
                address: '',
                passNo: '',
                licenseNo: '',
                nationNo: '',
                nationalityId: null,
                status: '',
                appType: 0,
                checkNo: '',
                transTypeName: '',
                madeName: '',
                transModel: '',
                transDate: '',
                plateNo: '',
                chassisNo: '',
                engineNo: '',
                transColor: '',
                receiptValue: '',
                regDate: '',
                isLegal: null,
                docImages: [],
                docTypes: [],
                hasExcept: null,
                actors: []
                // extendId: null,
            },
            acceptAppLabel: "",
            acceptModalFields: [
                {
                    id: "receiptNo",
                    type: "text",
                    placeholder: "رقم الإيصال المالي",
                    model: "receiptNo",
                    value: "",
                    required: "required",
                    span: "القيمة: 10 د.ل",
                },
                {
                    id: "note",
                    type: "text",
                    placeholder: "الملاحظات",
                    model: "note",
                    value: "",
                    required: false,
                },
            ],
            arriveModalFields: [
                {
                    id: "note",
                    type: "text",
                    placeholder: "الملاحظات",
                    model: "note",
                    value: "",
                    required: false,
                },
            ],

            investFields: {
                // appId: { id: 'appId', label: '', type: 'hidden', value: this.ID, required: "required", disabled: true },
                reasone: { id: 'reasone', label: 'السبب القانوني', type: 'text', placeholder: 'سبب الاستثناء بما يتوافق مع المستندات المرفقة', value: null, required: "required" },
                note: { id: 'note', label: 'ملاحظات: ', type: 'text', placeholder: 'ملاحظات: (اختياري)', value: null },
            },
            dropFields: {
                // appId: { id: 'appId', label: '', type: 'hidden', value: this.ID, required: "required", disabled: true },
                reasone: { id: 'reasone', label: 'السبب القانوني', type: 'text', placeholder: 'سبب طلب الإسقاط بما يتوافق مع المستندات المرفقة', value: null, required: "required" },
                note: { id: 'note', label: 'ملاحظات: ', type: 'text', placeholder: 'ملاحظات: (اختياري)', value: null },
            },
            investDocs: [],
            dropDocs: [],
            receipt: 0,
            alertSubject: "",
            alertContent: "",
            nationalities: [],
            exceptionList: [],
            dropList: []
        };
    },
    computed: {
        ...mapGetters([/* 'getInspectors' */, 'getUser', 'getNationalities', 'getDeparts'])
    },
    async created() {
        await this.fetchOptions();
    },
    methods: {
        /** */
        ...mapActions([
            // 'fetchInspectors',
            'fetchUser',
            'fetchDeparts',
            'fetchNationalities',
        ]),
        /********************************/
        /** */
        async fetchOptions() {
            // if (this.getInspectors.length == 0) {
            //     await this.fetchInspectors();
            // }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            if (this.getNationalities.length == 0) {
                await this.fetchNationalities();
            }
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts(); // Fetch and store in Vuex
            }
            this.nationalities = this.getNationalities
            try {
                const [applicant,invResponse,dropResponse] = await Promise.all([
                    this.$axios.get("api/employee/applicant/getapplicantbyid/" + this.Id),
                    this.$axios.get("api/docs/getinvestdocs"),
                    this.$axios.get("api/docs/getdropdocs"),
                ]);
                if (applicant?.data.isSuccess) {
                    // this.acceptModalFields[1].options = this.getInspectors;
                    this.applicant = applicant.data.applicant;
                    this.acceptModalFields[0].span = this.applicant.receiptValue + ' د.ل';
                    this.acceptAppLabel = `قبول الطلب (${this.$appType.desc[this.applicant.appType]})`
                    if (!this.applicant.isLegal) {
                        this.$tempAlert("لدى المسافر سيارة معلّقة بالنظام (إحالة إلى التحقيق)", 'danger', 8000);
                    }
                } else {
                    this.$tempAlert(applicant?.data.msg, 'warning');
                }
                if (invResponse?.data.isSuccess) {
                    this.investDocs = invResponse?.data.docTypes;
                    } else {
                    this.$tempAlert(invResponse.data.msg);
                    }
                    if (dropResponse?.data.isSuccess) {
                    this.dropDocs = dropResponse?.data.docTypes;
                    } else {
                    this.$tempAlert(dropResponse.data.msg);
                    }
            } catch (error) {
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg ?? "مشكلة في الاتصال بالخادم", 'danger');
                }
                console.error("Error fetching options:", error);
            }
        },
        /** */
        async getExceptList(){
            try {
                const response = await this.$axios.post("api/employee/except/getexceptlist",
                    {appId: this.Id}
                );
                if (response.data.isSuccess) {
                    this.exceptionList = response.data.excList;
                } else {
                    this.$tempAlert(response?.data.msg, 'warning');
                }
            } catch (error) {
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg ?? "مشكلة في الاتصال بالخادم", 'danger');
                }
            }
        },
        /** */
        // async getDropList(){
        //     try {
        //         const response = await this.$axios.post("api/employee/except/getdroplist",
        //             {appId: this.Id}
        //         );
        //         if (response.data.isSuccess) {
        //             this.dropList = response.data.dropList;
        //         } else {
        //             this.$tempAlert(response?.data.msg, 'warning');
        //         }
        //     } catch (error) {
        //         if (error.response?.data) {
        //             this.$tempAlert(error.response.data.msg ?? "مشكلة في الاتصال بالخادم", 'danger');
        //         }
        //     }
        // },

        async modalSubmit() {
            const formData = new FormData();
            formData.append("applicantId", this.Id);
            this.acceptModalFields.forEach((field) => {
                formData.append(field.model, field.value);
            });
            try {
                const response = await this.$axios.post("api/employee/applicant/acceptapp",
                    formData,
                    {
                        withCredentials: true
                    }
                );
                if (response.data.isSuccess) {
                    this.alertSubject = "تمت العملية بنجاح";
                    this.alertContent = response.data.msg;
                    await this.printPdf();
                } else {
                    this.alertSubject = "فشل العملية";
                    this.alertContent = response.data.msg;
                }
                // Trigger the modal display
                const alertModalInstance = new Modal(this.$refs.alertModal.$el);
                alertModalInstance.show();
                this.$refs.alertModal.isHidden = 0; // Start the timer
            } catch (error) {
                if (error.response?.data) {
                    this.alertSubject = "فشل العملية";
                    this.alertContent = error.response.data.msg;
                    const alertModalInstance = new Modal(this.$refs.alertModal.$el);
                    alertModalInstance.show();
                    this.$refs.alertModal.isHidden = 0; // Start the timer
                }
                console.error("Submission error:", error);
            }
        },
        /***************************/
        /** Fetch the report as a pdf file */
        async printPdf() {
            try {
                const response = await this.$axios.post(`api/employee/applicant/printreceipt`, {applicantId: this.Id},
                    {
                        responseType: 'blob',
                    });

                console.log(response)

                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                // Open in a new tab
                window.open(url, '_blank')

                // Optional cleanup (after some delay to let the file load)
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 100)
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },
        /***************************/
        /** */
        async arriveVehicle() {
            const formData = new FormData();
            formData.append("applicantId", this.Id);
            this.arriveModalFields.forEach((field) => {
                formData.append(field.model, field.value);
            });
            try {
                const response = await this.$axios.post("api/employee/applicant/returnapp", formData);
                if (response.data.isSuccess) {
                    this.alertSubject = "تمت العملية بنجاح";
                    this.alertContent = response.data.msg;
                } else {
                    this.alertSubject = "فشل العملية";
                    this.alertContent = response.data.msg;
                }
                // Trigger the modal display
                const alertModalInstance = new Modal(this.$refs.alertModal.$el);
                alertModalInstance.show();
                this.$refs.alertModal.isHidden = 0; // Start the timer
            } catch (error) {
                if (error.response?.data) {
                    this.alertSubject = "فشل العملية";
                    this.alertContent = error.response.data.msg;
                    const alertModalInstance = new Modal(this.$refs.alertModal.$el);
                    alertModalInstance.show();
                    this.$refs.alertModal.isHidden = 0; // Start the timer
                }
                console.error("Submission error:", error);
            }
        },
        /***************************/
        /** */
        investArrive(){
            this.exceptVehicle(2)
        },
        dropVehicle(){
            this.exceptVehicle(3)
        },
        /***************************/
        /** */
        async exceptVehicle(excType) {
            const formData = new FormData();
            const fields = (excType == 2) ? this.investFields : this.dropFields ;
            const docs = (excType == 2) ? this.investDocs : this.dropDocs ;
            formData.append("appId", this.Id)
            formData.append("excType", excType)
            Object.keys(fields).forEach((key) => {
                if (fields[key].value !== null) {
                    formData.append(key, fields[key].value);
                }
            });

            docs.forEach(doc => {
                if (doc.file) {
                    formData.append('docImages', doc.file);
                    formData.append('docTypes', doc.id);
                }
            });
            try {
                const response = await this.$axios.post("api/employee/except/register", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response?.data.isSuccess) {
                    this.$tempAlert(response?.data.msg ?? 'تمت العملية بنجاح', 'success');
                } else {
                    this.$tempAlert(response?.data.msg ?? 'فشل العملية', 'warning');
                }
                
            } catch (error) {
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
                console.error("Submission error:", error);
            }
        },
        /***************************/
    },
    /***************************/
    components: {
        GeneralModal,
        AlertModal,
        ExceptionListModal,
    }
};
</script>

<style scoped>
/* .applicant-section {
    background-color: #ffffff78;
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: #fff;
    border-radius: 10px;
} */

.card {
    border-radius: 10px;
}

.card-body {
    padding: 1.5rem;
}

.card-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
}

.card-img-top {
    object-fit: cover;
    height: 250px;
    border-radius: 10px;
}

.doc-thumbnail {
    object-fit: cover;
    height: 250px;
    /* Maintain consistent height for all document images */
    border-radius: 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* Smooth transition */
}

.doc-thumbnail:hover {
    transform: scale(1.1);
    /* Scale up the image */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    /* Add shadow for depth effect */
}

h2,
h5 {
    font-weight: 600;
    text-align: center;
}
/* h2{
    font-weight: 600;
} */

.text-success {
    color: #28a745;
}

.text-danger {
    color: #dc3545;
}

.container {
    max-width: 1200px;
}

.applicant-card {
    min-height: 350px;
    /* Ensure all cards have the same height */
    display: flex;
    flex-direction: column;
}

.list-unstyled li {
    font-size: 1.1rem;
}

h6.card-title {
    font-size: 1rem;
    font-weight: 500;
}

.text-white {
    color: white;
}
</style>